import React from 'react';
import { motion } from 'framer-motion';
import { PenTool, Megaphone, Rocket, Wallet, MessageSquare, Camera } from 'lucide-react';
const services = [{
  icon: PenTool,
  title: 'Creación de Ads',
  description: 'Creativos y copies diseñados para convertir. Cada pieza responde a un objetivo claro dentro de tu estrategia.'
}, {
  icon: Megaphone,
  title: 'Manejo de Campañas',
  description: 'Gestión profesional en Meta Ads y Google Ads. Configuración, segmentación y monitoreo continuo.'
}, {
  icon: Rocket,
  title: 'Optimización y Escalamiento',
  description: 'Análisis de rendimiento para identificar oportunidades de mejora y escalar lo que funciona.'
}, {
  icon: Wallet,
  title: 'Control de Presupuesto',
  description: 'Distribución estratégica de tu inversión para maximizar resultados y reducir desperdicio.'
}, {
  icon: MessageSquare,
  title: 'Consultoría',
  description: 'Asesoría estratégica para definir objetivos, canales y enfoque publicitario alineado con tus metas de negocio.'
}, {
  icon: Camera,
  title: 'Producción de Creativos',
  description: 'Desarrollo de piezas visuales y audiovisuales pensadas para captar atención y generar acción en cada plataforma.'
}];
export function Services() {
  return <section id="servicios" className="py-20 md:py-28 bg-slate-50" data-id="element-154">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-155">
        <div className="mb-16" data-id="element-156">
          <span className="text-blue-600 font-semibold tracking-wide uppercase text-sm" data-id="element-157">
            Lo que hacemos
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mt-2" data-id="element-158">
            Servicios Principales
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-159">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-white rounded-xl p-8 border border-slate-200 shadow-sm flex flex-col sm:flex-row gap-6 items-start" data-id="element-160">
              <div className="flex-shrink-0" data-id="element-161">
                <div className="w-14 h-14 bg-blue-50 rounded-xl flex items-center justify-center text-blue-600" data-id="element-162">
                  <service.icon className="w-7 h-7" data-id="element-163" />
                </div>
              </div>
              <div data-id="element-164">
                <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-165">
                  {service.title}
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-166">
                  {service.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}